module.exports = true;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_library.js
// module id = 112
// module chunks = 0